// ============================================================================
// QuoteBrainAlertBanner: Peter's in-app Quote Brain alert (slice LIVE)
// ----------------------------------------------------------------------------
// Every Quote Brain alert (a failed run, a job over $5, a run that could not
// start, the day-7 and day-14 reports) shows here for the one account that
// reads the report, so an alert never depends on email alone. The server
// decides who that is; for anyone else the hook returns no alerts and this
// renders nothing. Dismiss acknowledges the newest alert on the server.
// ============================================================================

import React from 'react';
import type { QuoteBrainAlert } from '../../services/quote-brain-report-api';
import '../../styles/quote-brain-report.css';

interface QuoteBrainAlertBannerProps {
    alerts: QuoteBrainAlert[];
    mail: { configured: boolean; recipientSet: boolean } | null;
    onOpenReport: () => void;
    onDismiss: (id: string) => void;
}

export function QuoteBrainAlertBanner({ alerts, mail, onOpenReport, onDismiss }: QuoteBrainAlertBannerProps) {
    const newest = alerts[0];
    if (!newest) return null;
    const failure = alerts.some((a) => a.kind === 'run_failed' || a.kind === 'trigger_failed');
    const others = alerts.length - 1;
    const emailNote = mail && !mail.configured ? ' Not emailed: server email is off.' : '';
    return (
        <div role={failure ? 'alert' : 'status'} className={`qbr-top-banner${failure ? ' qbr-top-banner--danger' : ''}`} data-testid="quote-brain-alert-banner">
            <span className="qbr-top-banner__text" title={newest.body}>
                <strong>Quote Brain:</strong> {newest.subject.replace(/^\[Quote Brain\]\s*/, '')}
                {others > 0 ? ` (and ${others} more)` : ''}.{emailNote}
            </span>
            <button type="button" className="qm-btn qm-btn--secondary qm-inline-action-btn" onClick={onOpenReport}>Open report</button>
            <button type="button" className="qm-btn qm-btn--quiet qm-inline-action-btn" onClick={() => onDismiss(newest.id)}>Dismiss</button>
        </div>
    );
}
